interface IIsOnPageParams {
    current?: string;
    page: string | RegExp;
}

export const isOnPage = ({ current, page }: IIsOnPageParams): boolean => {
    if (!current) {
        return false;
    }

    if (typeof page === "string") {
        return page === current;
    }

    return page.test(current);
};

export const CI_PAGE_COLLECTION = [
    /^activation/,
    /^track/,
    /^sw/,
    /^digitalsuite/,
    /^organicsearch/,
    /^ranktracker/,
    /^paidsearch/,
    /^search_website_topics/,
];

export const SI_PAGE_COLLECTION = [/^salesIntelligence-/];

export const CI_AND_SI_PAGE_COLLECTION = [...CI_PAGE_COLLECTION, ...SI_PAGE_COLLECTION];
